import { render } from "./RemittanceFunds.vue?vue&type=template&id=0b70e99c&scoped=true&ts=true"
import script from "./RemittanceFunds.vue?vue&type=script&lang=ts"
export * from "./RemittanceFunds.vue?vue&type=script&lang=ts"

import "./RemittanceFunds.vue?vue&type=style&index=0&id=0b70e99c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b70e99c"]])

export default __exports__